// extracted by mini-css-extract-plugin
export default {"uppercase":"uppercase__S2B_p","hidden":"hidden___YqHx","cantScanButton":"cantScanButton__ujnrZ","cantScanContainer":"cantScanContainer___Hlsw"};